import api from "../../../api";
import React from "react";
import utils from "../../../utils";
import values from "../../../values";
import Context from "../../../context";
import Components from "../Components";
import SchoolScreen from "..";

import { TModal } from "../../../types/common.type";
import { useQuery } from "react-query";
import { DeleteModal } from "../../../components";
import { IFindUserInformation } from "../../../types/common.interface";
import { ICreateAndUpdateSchool } from "../../../types/school.interface";
import Cookies from "js-cookie";

const SchoolContainer = () => {
  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Value Validations
  // ** --------------------------------------------------------------------------------------------------------------------
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedSchool, setSelectedSchool] = React.useState<any>();
  const [allSchoolInfo, setAllSchoolInfo] =
    React.useState<IFindUserInformation>({
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      page: 1,
    });
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // !! ====================================================================================================================
  // !! --------------------------------------------------------------------------------------------------------------------
  // !!                                                Start API Cal
  // !! --------------------------------------------------------------------------------------------------------------------

  let cityInfo: any;
  let provinceId: string | undefined;

  Cookies.get("city") != "undefined"
    ? (cityInfo = JSON.parse(Cookies.get("city") as string))
    : (cityInfo = undefined);
  Cookies.get("province")
    ? (provinceId = JSON.parse(Cookies.get("province") as string))
    : (provinceId = undefined);

  const [requestSchool, setRequestSchool] =
    React.useState<IFindUserInformation>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      filters: {
        city: cityInfo,
        province: { _id: provinceId },
      },
    });

  // ? Panel-wide academic year (سال تحصیلی). It has to be part of the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const resultSchool = useQuery(
    [
      values.useQueryKeys.getAllSchool,
      requestSchool?.page,
      requestSchool?.search?.value,
      requestSchool?.filters,
      selectedYear?._id,
    ],
    () =>
      api.post.common.findSchoolPost({
        filters: requestSchool?.filters,
        search: requestSchool?.search,
        limit: requestSchool?.limit,
        page: requestSchool?.page,
        academicYear: selectedYear?._id,
      })
  );
  const { refetch } = resultSchool;

  // !! --------------------------------------------------------------------------------------------------------------------
  // !! ====================================================================================================================

  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Local Functions
  // ** --------------------------------------------------------------------------------------------------------------------
  async function createFunction(formData: ICreateAndUpdateSchool) {
    setIsLoading(true);
    const result = await api.post.common.createSchoolCompany(formData);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  // ** --------------------------------------------------------------------------------------------------------------------
  async function updateFunction(formData: ICreateAndUpdateSchool) {
    setIsLoading(true);
    const result = await api.put.common.updateSchool(formData);
    if (result) {
      utils.successHandler(Number(2010));
      refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  // ** --------------------------------------------------------------------------------------------------------------------
  async function deleteFunction(userId: string) {
    setIsLoading(true);
    const result = await api.dele.common.deleteSchool(userId);
    if (result) {
      utils.successHandler(Number(2010));
      refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  // ** --------------------------------------------------------------------------------------------------------------------
  async function approveFunction(userId: string) {
    setIsLoading(true);
    const result = await api.put.common.approveSchool(userId);
    if (result) {
      utils.successHandler(Number(2010));
      refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  // ** --------------------------------------------------------------------------------------------------------------------
  async function rejectFunction(userId: string) {
    setIsLoading(true);
    const result = await api.put.common.rejectSchool(userId);
    if (result) {
      utils.successHandler(Number(2010));
      refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // ?? ====================================================================================================================
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ??                                                JSX Container
  // ?? --------------------------------------------------------------------------------------------------------------------
  return (
    <Context.SchoolScreen.Provider
      value={{
        showModal,
        isLoading,
        setShowModal,
        allSchoolInfo,
        selectedSchool,
        createFunction,
        updateFunction,
        deleteFunction,
        rejectFunction,
        approveFunction,
        setAllSchoolInfo,
        setSelectedSchool,
        requestSchool,
        setRequestSchool,
      }}
    >
      <SchoolScreen rqSchool={resultSchool} />
      <Components.Approve />
      <Components.Reject />
      <DeleteModal
        open={showModal === "DELETE"}
        data={selectedSchool}
        loading={isLoading}
        onClose={() => setShowModal("NONE")}
        onSubmit={(userId: string) => deleteFunction(userId)}
      />
    </Context.SchoolScreen.Provider>
  );
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ?? ====================================================================================================================
};

export default SchoolContainer;
